import { render } from "./customerService.vue?vue&type=template&id=3a39455a"
import script from "./customerService.vue?vue&type=script&lang=js"
export * from "./customerService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__